import { Button } from "@appkit4/react-components/button";
import { Modal } from "@appkit4/react-components/modal";

interface SessionExpiryModalProps {
  visible: boolean;
  onLogout: () => void;
  onStaySignedIn: () => void;
}

/**
 * Non-dismissable idle-session warning, matching the oh-marketplace pattern.
 */
export function SessionExpiryModal({
  visible,
  onLogout,
  onStaySignedIn,
}: SessionExpiryModalProps) {
  return (
    <Modal
      title="Do you need more time?"
      visible={visible}
      maskCloseable={false}
      closable={false}
      modalStyle={{ width: "540px" }}
      footerStyle={{ paddingTop: "8px" }}
      footer={
        <>
          <Button kind="secondary" onClick={onLogout}>
            Log out
          </Button>
          <Button kind="primary" onClick={onStaySignedIn}>
            Stay signed in
          </Button>
        </>
      }
    >
      Due to inactivity, your session will end soon.
      <br />
      Do you want to stay signed in?
    </Modal>
  );
}

export default SessionExpiryModal;
